import { MediaCatalog } from './catalog'

export const MediaPage = () => <MediaCatalog />
